let features = {};
let app = process.env.REACT_APP_ENV;
if (app && app.includes("sdk")) {
    features = require("./sdk")
} else {
    features = require("./solo")
}

export default features.features
